import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'jhi-spinner-overlay',
   templateUrl: './spinner-overlay.component.html',
   styleUrls: ['./spinner-overlay.component.scss']
})
export class SpinnerOverlayComponent implements OnInit {

   constructor() {
   }

   ngOnInit(): void {
   }

}
